<template>
  <div class="popstyle2">
    <b-modal id="filtros" ref="filtrosmodal" size="lg" @hidden="hideModal" class="fixedModal">
          <b-form>
            <b-form-row>
              <b-col v-if="type == 'comercial'">
                <b-form-group id="claseestablecimiento"
                              label="Clase de establecimiento GN:"
                              label-for="claseestablecimientoinput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect multiple size="md" v-model="filtros.id_clase_establecimiento_gn_comercial"
                                :options="optsfiltros.id_clase_establecimiento_gn_comercial"
                                id="claseestablecimientoinput"
                                class="mb-3"
                                placeholder="Todos"
                                label="tipo"
                                track-by="id"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="statusgestion"
                              label="Status gestión:"
                              label-for="statusgestioninput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect multiple size="md"
                                v-model="filtros['id_status_gestion_' + type]"
                                :options="optsfiltros.id_status_gestion"
                                id="statusgestioninput"
                                placeholder="Todos"
                                label="status"
                                track-by="id"></multiselect>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group id="motivonopotencial"
                              label="Motivo No Potencial:"
                              label-for="motivonopotencialinput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect size="md"
                              v-model="filtros.motivo_no_potencial"
                              :options="optsfiltros.motivo_no_potencial"
                              id="motivonopotencialinput"
                              class="mb-3"
                              placeholder="Todos"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="gas finca"
                              label="Gas en finca:"
                              label-for="gasfincainput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect multiple size="md"
                              v-model="filtros.id_gas_finca"
                              :options="optsfiltros.id_gas_finca"
                              id="gasfincainput"
                              placeholder="Todos"
                              label="gas"
                              track-by="id"
                  ></multiselect>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group id="distancia"
                              label="Distancia a red distribución:"
                              label-for="distanciainput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect size="md"
                                v-model="filtros.in_service_mains_distance"
                                :options="optsfiltros.in_service_mains_distance"
                                label="label"
                                track-by="id"
                                id="distanciainput" class="mb-3"
                  placeholder="Cualquiera"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="municipios"
                          label="Provincias:"
                          label-size="md"
                          :label-cols="5">
                          <!-- <b-btn v-b-modal.municipiomodal>Get</b-btn> -->
                  <multiselect size="md" v-model="filtros.provincia" :options="optsfiltros.provincia" id="provinciasinput" class="mb-3"
                              multiple placeholder="Todas"/>
                </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group v-if="type == 'comercial'" id="categoriaestablecimiento"
                              label="Categoría establecimiento:"
                              label-for="categoriaestablecimientoinput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect multiple v-model="filtros.id_categoria_gn_comercial"
                              :options="optsfiltros.id_categoria_gn_comercial"
                              id="categoriaestablecimientoinput"
                              label="categoria_gn_comercial"
                              track-by="id"
                              placeholder="Todos" @input="setOptionsTipoEstablecimiento()"></multiselect>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group v-if="type == 'comercial'" id="tipoestablecimiento"
                              label="Tipo Establecimiento:"
                              label-for="tipoestablecimientoinput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect size="md" v-model="filtros.id_tipo_establecimiento_gn_comercial"
                                :options="optsfiltros.id_tipo_establecimiento_gn_comercial"
                                id="tipoestablecimientoinput"
                                class="mb-3"
                                placeholder="Todos"
                                label="tipo"
                                multiple
                                track-by="id"
                                preselectFirst/>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-form-group id="escliente"
                              label="Es cliente:"
                              label-for="esclienteinput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect size="md" v-model="filtros.cliente" :options="optsfiltros.cliente" id="esclienteinput" class="mb-3" placeholder="Todos"
                              track-by="id"
                              label="text"/>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="visitadogestor"
                              label="Visitado gestor:"
                              label-for="visitadogestorinput"
                              label-size="md"
                              :label-cols="5">
                  <multiselect multiple v-model="filtros.visitado_gestor" :options="optsfiltros.visitado_gestor" id="visitadogestorinput"
                  placeholder="Todos"></multiselect>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-form>

          <div slot="modal-footer">
            Resultados: {{count}}
            &nbsp;
            <b-button @click="clearFilter">Limpiar</b-button>
            <b-button @click="saveFilter">Guardar</b-button>
            <b-button @click="$refs.filtrosmodal.hide()">Cancelar</b-button>
            <b-button @click="validate">Aplicar</b-button>
          </div>

        </b-modal>

        <b-modal id="municipiomodal" ref="municipiomodal" size="lg">
          <b-form>
            <b-form-group>
              <checkBox id="checktodos" v-model="filtros.municipiostodos" label="Todas"></checkBox>
            </b-form-group>
            <b-card>
              <div slot="header">
                <b-row>
                  <b-col lg="3">
                    <checkBox id="conclientes" v-model="filtros.conclientes" label="Con clientes"></checkBox>
                  </b-col>
                  <b-col size="lg">
                    <b-form-group horizontal id="provincias"
                                  label="Provincias:"
                                  label-for="provinciasinput"
                                  label-size="lg"
                                  :label-cols="5">
                      <!-- <b-form-select size="lg" v-model="filtros.provincias" :options="optsfiltros.provincias" id="provinciasinput" class="mb-3"
                      @input="getMunicipios"/>
                      </b-form-input>-->
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <!-- <b-card-body style="max-height:350px;overflow-y:auto;">
                <ul class="ul-municipio">
                  <li v-for="(municipio,i) in optsfiltros.municipios" :key="municipio.entity_name + '_' + i">
                    <checkBox
                      :label="municipio.entity_name"
                      :ref="'checkbox_municipio_'+municipio.entity_name"
                      emitOnChange
                      :initialChecked="initialCheckedMunicipio(municipio.entity_name)"
                      @checkbox-checked="checkboxToggled(true, municipio.entity_name)"
                      @checkbox-unchecked="checkboxToggled(false, municipio.entity_name)"
                      :key="'checkbox '+ municipio.entity_name + '_' + i"></checkBox>
                  </li>
                </ul>
              </b-card-body> -->
              <!-- <b-form-group class="mt-2" id="municipios"
                            label="Municipios:"
                            label-for="municipiosinput"
                            label-size="lg">
                <tag ref="tags" @removeMunicipioTag="" @removeProvinciaTag=""></tag>
              </b-form-group> -->
            </b-card>
            <b-row class="mt-2">
              <b-col>
                <b-button>Cancelar</b-button>
                <b-button @click="applyFilter">Aplicar</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>
  </div>
</template>

<style>
.fix-bottom-right {
  bottom: 5px;
  position: absolute;
  right: 5px;
  z-index: 2;
}
.hideFilter .VueTables__filters-row{
  display: none;
}

</style>

<script>
import checkBox from '@/components/Modules/Misc/checkBox.vue';

export default {
  name: 'FilterModal',
  props: ['optsfiltros', 'filtros', 'type'],
  components: {
    checkBox
  },
  data () {
    return {
      intervalWaitForTipoEstablecimiento: null,
      count: 0,
      loadingtipos: false,
      lastCountRequestTimestamp: 0
      // filtros: {
      //   tipoestablecimiento: '',
      //   statusgestion: [],
      //   motivonopotencial: '',
      //   gasfinca: [],
      //   distancia: null,
      //   escliente: null,
      //   visitadogestor: [],
      //   provincias: [],
      //   conclientes: false
      // }
    };
  },
  methods: {
    show: function () {
      this.$refs.filtrosmodal.show();
    },
    applyCount: function () {
      let requestTimestamp = new Date().getTime();
      this.lastCountRequestTimestamp = Math.max(requestTimestamp, this.lastCountRequestTimestamp);

      this.count = '...';
      var params = {...{type: this.type}};

      if (this.type === 'comercial') {
        // console.log(requestTimestamp + ' starting')
        if (this.filtros.id_clase_establecimiento_gn_comercial.length > 0) {
          params.id_clase_establecimiento_gn_comercial__in = this.filtros.id_clase_establecimiento_gn_comercial.map(e => e.id);
        }
        if (this.filtros.id_categoria_gn_comercial.length > 0) {
          params.id_categoria_gn_comercial__in = this.filtros.id_categoria_gn_comercial.map(e => e.id);
        }
        if (this.filtros.id_tipo_establecimiento_gn_comercial.length > 0) {
          params.id_tipo_establecimiento_gn_comercial__in = this.filtros.id_tipo_establecimiento_gn_comercial.map(e => e.id);
          // delete params.id_tipo_establecimiento_gn_comercial
        }

        if (this.filtros.id_status_gestion_comercial.length > 0) {
          params.id_status_gestion_comercial__in = this.filtros.id_status_gestion_comercial.map(e => e.id);
        }
      } else if (this.type === 'caldera') {
        if (this.filtros.id_status_gestion_caldera.length > 0) {
          params.id_status_gestion_caldera__in = this.filtros.id_status_gestion_caldera.map(e => e.id);
        }
        if (this.filtros.id_status_gestion_caldera.length > 0) {
          params.id_status_gestion_caldera__in = this.filtros.id_status_gestion_caldera.map(e => e.id);
        }
      }
      if (this.filtros.visitado_gestor.length > 0) {
        params.visitado_gestor = this.filtros.visitado_gestor;
      }
      if (this.filtros.cliente) {
        params.cliente = this.filtros.cliente.id;
      }
      if (this.filtros.in_service_mains_distance) {
        params.in_service_mains_distance__lte = this.filtros.in_service_mains_distance.id;
      }

      if (this.filtros.motivo_no_potencial) {
        params.motivo_no_potencial = this.filtros.motivo_no_potencial;
      }

      if (this.filtros.id_gas_finca.length > 0) {
        // TODO maybe you prefer change column name in query
        if (this.type === 'comercial') {
          params.id_gas_finca__in = this.filtros.id_gas_finca.map(e => e.id);
        } else if (this.type === 'caldera') {
          params.id_gas_en_finca__in = this.filtros.id_gas_finca.map(e => e.id);
        }
      }
      if (this.filtros.provincia.length > 0) {
        params.provincia__in = this.filtros.provincia;
        delete params.provincia;
      }

      params.user = this.$parent.user.username;

      this.$parent.applyCountParams(this.type, params);

      this.$http.post('count/', {params: params}).then(result => {
        // if (this.type === 'comercial') {
        //   // console.log(requestTimestamp + ' finished: ' + result.data.count)
        //   if (requestTimestamp === this.lastCountRequestTimestamp) {
        //     // console.log(requestTimestamp + ' applying bcoz equals ' + this.lastCountRequestTimestamp)
        //   } else {
        //     // console.log(requestTimestamp + ' discarded bcoz not equals ' + this.lastCountRequestTimestamp)
        //   }
        // }

        if (requestTimestamp === this.lastCountRequestTimestamp) {
          this.count = result.data.count;
        }
      });
    },
    applyFilter: function () {
      this.$parent.applyFilter(this.type);
      this.$refs.filtrosmodal.hide();
    },
    clearFilter: function () {
      this.$parent.clearFilter(this.type);
      // this.$refs.filtrosmodal.hide()
    },
    saveFilter: function () {
      var gas = this.filtros.id_gas_finca.map(e => e.id);
      var status = this.filtros['id_status_gestion_' + this.type].map(e => e.id);

      var cliente = null;
      if (this.filtros.cliente) {
        cliente = this.filtros.cliente.id;
      }
      var distance = null;
      if (this.filtros.in_service_mains_distance) {
        distance = this.filtros.in_service_mains_distance.id;
      }

      var clase = null;
      if (this.filtros.id_clase_establecimiento_gn_comercial) {
        clase = this.filtros.id_clase_establecimiento_gn_comercial.map(e => e.id);
      }
      // if (this.filtros.id_clase_establecimiento_gn_comercial) {
      //   clase = this.filtros.id_clase_establecimiento_gn_comercial.id
      // }

      var filtro = {};

      if (this.type === 'comercial') {
        filtro = {
          usuario: this.$parent.user.id,
          nombre_filtro: null,
          status: status.toString(),
          categoria_establecimiento: this.filtros.id_categoria_gn_comercial.map(e => e.id).toString(),
          id_tipo_establecimiento: this.filtros.id_tipo_establecimiento_gn_comercial.map(e => e.id).toString(),
          id_motivo_no_potencial: this.filtros.motivo_no_potencial,
          id_clase_establecimiento: clase.toString(),
          gas_en_finca: gas.toString(),
          in_service_mains_distance: distance,
          cod_gas_provincia: this.filtros.provincia.toString(),
          es_cliente: cliente,
          visitado_gestor: this.filtros.visitado_gestor.toString()
        };
      } else {
        filtro = {
          usuario: this.$parent.user.id,
          nombre_filtro: null,
          status: status.toString(),
          categoria_establecimiento: this.filtros.id_categoria_gn_comercial.map(e => e.id).toString(),
          id_motivo_no_potencial: this.filtros.motivo_no_potencial,
          gas_en_finca: gas.toString(),
          in_service_mains_distance: distance,
          cod_gas_provincia: this.filtros.provincia.toString(),
          es_cliente: cliente,
          visitado_gestor: this.filtros.visitado_gestor.toString()
        };
      }

      var url = 'filtros_usuarios/';
      if (this.type === 'caldera') {
        url = 'filtros_caldera/';
      }
      this.$http.post(url, filtro).then(result => {
        alert('Filtro guardado con éxito!');
      });
    },
    hideModal: function () {
      var th = this;
      setTimeout(function () {
        th.$parent.filtermodal = false;
      }, 200);
      //
    },
    parsedFilter: function () {
      this.$parent.parsedFilter();
      this.$refs.filtrosmodal.hide();
    },
    setOptionsTipoEstablecimiento (d = []) {
      if (this.filtros.id_categoria_gn_comercial.length) {
        this.loadingtipos = true;
        var params = {params: {not_paginated: true, 'id_categoria_gn_comercial__in': this.filtros.id_categoria_gn_comercial.map(v => v.id)}};
        this.$http.get('tipos_comercial/', params).then(result => {
          var todas = [];
          for (let i in this.filtros.id_categoria_gn_comercial) {
            var cat = this.filtros.id_categoria_gn_comercial[i];

            todas.push({id: 'Todas ' + cat.id, tipo: 'Todas ' + cat.categoria_gn_comercial});
          }
          this.optsfiltros.id_tipo_establecimiento_gn_comercial = todas.concat(result.data);
          this._removeOptsFromRequest();
          if (d.length > 0) {
            this.filtros.id_tipo_establecimiento_gn_comercial = this.optsfiltros.id_tipo_establecimiento_gn_comercial.filter(e => d.indexOf(e.id.toString()) > -1);
          } else {
            if (!this.filtros.id_tipo_establecimiento_gn_comercial.length) { this.filtros.id_tipo_establecimiento_gn_comercial = [this.optsfiltros.id_tipo_establecimiento_gn_comercial[0]]; }
          }
          this.loadingtipos = false;
        });
      } else {
        this.filtros.id_tipo_establecimiento_gn_comercial = [];
        this.optsfiltros.id_tipo_establecimiento_gn_comercial = [];
      }
    },
    validate () {
      if (this.filtros.id_categoria_gn_comercial.length && !this.filtros.id_tipo_establecimiento_gn_comercial.length) {
        alert('Debe elegir al menos un tipo establecimiento');
      } else {
        this.applyFilter();
      }
    },
    _removeOptsFromRequest () {
      this.filtros.id_tipo_establecimiento_gn_comercial = this.filtros.id_tipo_establecimiento_gn_comercial.filter(v => this.optsfiltros.id_tipo_establecimiento_gn_comercial.find(i => i.id === v.id));
    },
    filterIsSet: function () {
      var gas = this.filtros.id_gas_finca.map(e => e.id).toString();
      var status = this.filtros['id_status_gestion_' + this.type].map(e => e.id).toString();
      var visitadoGestor = this.filtros.visitado_gestor.toString();

      if (gas || status || visitadoGestor) {
        return true;
      } else {
        return false;
      }
    },
    setInitialFiltros (data) {
      try {
        var status = data.status.split(',');
        this.filtros['id_status_gestion_' + this.type] = this.optsfiltros.id_status_gestion.filter(e => e.id && status.indexOf(e.id.toString()) > -1);

        var gas = data.gas_en_finca.split(',');
        this.filtros.id_gas_finca = this.optsfiltros.id_gas_finca.filter(e => e.id && gas.indexOf(e.id.toString()) > -1);

        var visitadoGestor = data.visitado_gestor.split(',');
        this.filtros.visitado_gestor = this.optsfiltros.visitado_gestor.filter(e => e && visitadoGestor.indexOf(e) > -1);

        if (this.type === 'comercial') {
          var categoria = data.categoria_establecimiento.split(',');
          this.filtros.id_categoria_gn_comercial = this.optsfiltros.id_categoria_gn_comercial.filter(e => e.id && categoria.indexOf(e.id.toString()) > -1);
          if (data.id_tipo_establecimiento) {
            var tipo = data.id_tipo_establecimiento.split(',');
            this.setOptionsTipoEstablecimiento(tipo);
          }

          this.intervalWaitForTipoEstablecimiento = setInterval(() => {
            if (this.loadingtipos === false) {
              clearInterval(this.intervalWaitForTipoEstablecimiento);

              if (data.in_service_mains_distance) {
                this.filtros.in_service_mains_distance = this.optsfiltros.in_service_mains_distance.filter(e => e.id === data.in_service_mains_distance)[0];
              }

              if (data.id_clase_establecimiento) {
                let clase = data.id_clase_establecimiento.split(',');
                this.filtros.id_clase_establecimiento_gn_comercial = this.optsfiltros.id_clase_establecimiento_gn_comercial.filter(e => e.id && clase.indexOf(e.id.toString()) > -1);
              }

              if (data.es_cliente !== null) {
                this.filtros.cliente = this.optsfiltros.cliente.filter(e => e.id === data.es_cliente)[0];
              }

              if (data.id_motivo_no_potencial) {
                this.filtros.motivo_no_potencial = this.optsfiltros.motivo_no_potencial.filter(e => e === data.id_motivo_no_potencial)[0];
              }

              var provincias = data.cod_gas_provincia.split(',');
              this.filtros.provincia = this.optsfiltros.provincia.filter(e => e && provincias.indexOf(e) > -1);

              this.$parent.applyFilter(this.type, true);
              this.optsfiltros.initFilters = false;
            }
          }, 500);
        } else {
          this.$parent.applyFilter(this.type, false);
          this.optsfiltros.initFilters = false;
        }
      } catch (err) {
        console.log('Err', err);
      }
    }
  },
  mounted: function () {
    this.applyCount();
    this.$refs.filtrosmodal.show();
    // if (!this.filterIsSet() && this.optsfiltros.initFilters) {
    //   var url = 'filtros_usuarios/'
    //   if (this.type === 'caldera') {
    //     url = 'filtros_caldera/'
    //   }

    //   this.$http.get(url, {params: {usuario: this.$parent.user.id}}).then(result => {
    //     if (result.data.count > 0) {
    //       this.setInitialFiltros(result.data.results[0])
    //     }
    //   })
    // }
  },
  watch: {
    filtros: {
      handler: function (newValue) {
        this.applyCount();
      },
      deep: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/FilterModal.vue